
<div class="container-fluid">
    <div class="row g-4">
      <div class="col-12">
        <mat-card>
          <mat-card-content>
          
            <div *ngIf="isCollegeList">
                <button mat-flat-button color="primary" (click)="addCollege()">
                    Add Details 
                </button>
            </div>
           
           <div *ngIf="!isCollegeList || isEdit">
            <form [formGroup]="formGroup">
             
              <!-- Contact Information Section -->
              <div lass="row g-4 mt-3">
                <div class="col-12">
                  <h6 class="section-title">College information</h6>
                </div>

              
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>College name :</mat-label>
                    <input matInput formControlName="name" placeholder="Enter name" type="text">
                    <mat-error *ngIf="formGroup.get('name')?.errors?.['required']">
                       name is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>state  :</mat-label>
                    <input matInput formControlName="state" placeholder="Enter state" type="text">
                    <mat-error *ngIf="formGroup.get('state')?.errors?.['required']">
                      state is required
                    </mat-error>
                  </mat-form-field>
                </div>
                
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Nationality :</mat-label>
                    <input matInput formControlName="Nationality" placeholder="Enter Nationality" type="text">
                    <mat-error *ngIf="formGroup.get('Nationality')?.errors?.['required']">
                      Nationality is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>GRADUATION_LEVEL :</mat-label>
                    <input matInput formControlName="GRADUATION_LEVEL" placeholder="Enter GRADUATION_LEVEL" type="text">
                    <mat-error *ngIf="formGroup.get('GRADUATION_LEVEL')?.errors?.['required']">
                      GRADUATION_LEVEL is required
                    </mat-error>
                  </mat-form-field>
                </div>

                

              
               
                
              </div>
              

              <div class="row mt-4">
                <div class="col-12">
                  <div class="d-flex gap-3">
                    <button mat-flat-button color="primary" [disabled]="isLoading " (click)="saveCollege()" class="px-4 py-2">
                      {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                    <button mat-stroked-button [disabled]="isLoading" (click)="resetForm()" class="px-4 py-2">
                      RESET
                    </button>
  
                    <button *ngIf="isEdit || !isCollegeList" mat-flat-button color="primary"  (click)="back()" class="px-4 py-2">
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
       
  
      <div *ngIf="isCollegeList">
        <div class="sorting-table">
          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        
            <!-- Dynamic Columns -->
            <ng-container *ngFor="let column of displayedColumns.cols; let i = index" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ displayedColumns.label[i] | uppercase }}
              </th>
        
              <td mat-cell *matCellDef="let row; let rowIndex = index">
                <ng-container *ngIf="column === 'sno'; else otherCols">
                  {{ currentPage + (rowIndex +1)}}
                </ng-container>
                <ng-container *ngIf="column === 'createdAt'">
                    {{ row.createdAt | date:'dd/MM/yyyy'}}
                  </ng-container>
  


                <ng-template #otherCols>
                  <ng-container *ngIf="!['createdAt'].includes(column)">{{ row[column] }}</ng-container>
                  <!-- {{ row[column] }} -->
                </ng-template>
              </td>
            </ng-container>
        
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="edit(row)">
                    <mat-icon>edit</mat-icon> Edit
                  </button>
                  <button mat-menu-item (click)="delete(row)">
                    <mat-icon>delete</mat-icon> Delete
                  </button>
                </mat-menu>
              </td>
            </ng-container>
        
            <!-- Table Headers and Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns.cols.concat(['actions'])"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns.cols.concat(['actions'])"></tr>
        
          </table>
        </div>
        <mat-paginator
            [pageSizeOptions]="[5, 10, 15, 20]"
            [length]="pagination.length"
            [pageIndex]="pagination.page - 1"
            [pageSize]="pagination.limit"
            (page)="pageEvent($event)"
            *ngIf="pagination.length">
        </mat-paginator>
      </div>
      
   </mat-card-content>
      </mat-card>
      </div>
      </div>
      </div>